import { defineRoutes } from './types';

type StringOrNumber = string | number;

export type AdminOpsPathConfig = {
  inspectionSessions: undefined;
  inspectionSessionDetail: { id: StringOrNumber };
  inspectionMeasurements: undefined;
  countrySetting: { id: StringOrNumber };
};

/** Admin ops routes added/expanded for inspections, background jobs, planner. */
export const adminOpsRoutes = defineRoutes<AdminOpsPathConfig>()({
  inspectionSessions: {
    getPath: () => '/inspections/sessions',
    getBasePath: () => '/inspections/sessions'
  },
  inspectionSessionDetail: {
    getPath: (data) => `/inspections/sessions/${data.id}`,
    getBasePath: () => '/inspections/sessions/:id'
  },
  inspectionMeasurements: {
    getPath: () => '/inspections/measurements',
    getBasePath: () => '/inspections/measurements'
  },
  backgroundJobs: {
    getPath: () => '/system/background-jobs',
    getBasePath: () => '/system/background-jobs'
  },
  featureFlags: {
    getPath: () => '/system/feature-flags',
    getBasePath: () => '/system/feature-flags'
  },
  countrySettings: {
    getPath: () => '/system/country-settings',
    getBasePath: () => '/system/country-settings'
  },
  countrySetting: {
    getPath: (data) => `/system/country-settings/${data.id}`,
    getBasePath: () => '/system/country-settings/:id'
  },
  routePlanner: {
    getPath: () => '/routes/planner',
    getBasePath: () => '/routes/planner'
  }
});
